import { FunctionComponent } from 'react';
import { z } from 'zod';
import styled from 'styled-components';
import { boxShadow, spacingHelper } from '@property.com.au/ui-kit';
import { mapUIMessagePropertyTileToPropertyTileProps } from '../helpers/mapUIMessagePropertyTileToPropertyTileProps';

import { propertyTileComponentSchema } from '../hooks/uiComponentsSchemas';
import { PropertyTileV2 } from '../../../../../../app-kit/components/PropertyTile/PropertyTileV2';

const StyledPropertyTile = styled(PropertyTileV2)`
  ${boxShadow.boxShadowHover};
  width: 14rem;
`;

const PropertyTileComponentWrapper = styled.div`
  margin-left: ${spacingHelper('medium')};
`;

interface PropertyTileComponentProps {
  component: z.infer<typeof propertyTileComponentSchema>;
}

export const PropertyTileMessage: FunctionComponent<PropertyTileComponentProps> = ({
  component,
}) => (
  <PropertyTileComponentWrapper>
    <StyledPropertyTile {...mapUIMessagePropertyTileToPropertyTileProps(component)} />
  </PropertyTileComponentWrapper>
);
